import React, { Component } from 'react';
import cn from 'classnames';
import css from './css.css';
import { renderHTML, Icon, tooltipFactory, } from "~/native-ui"
const FontIconTooltip = tooltipFactory()(Icon);

export default class TooltipComponent extends Component {
    static defaultProps = {
        tooltipDelay: 500,
        toolTipHover : true,
        tooltipHideOnClick: true,
        tooltipShowOnClick: true,
        tooltipPosition: 'top',
        active: true
    };

    handleClick = (event) => {
        event.stopPropagation();
        event.preventDefault();
    };

    render() {
        let { tooltip, active, className, leftMargin, rightMargin, ...otherProps } =  this.props;

        if(!tooltip ||
            tooltip.length < 1 ||
            !active
        ) { return null; }

        console.log('rendering tooltip ', tooltip);

        let tooltipContent = renderHTML(tooltip);

        className = cn(css.toooltipIcon, className, {[css.leftMargin]:leftMargin, [css.rightMargin]:rightMargin});

        return (
            <FontIconTooltip
                onClick={this.handleClick}
                value="help"
                tooltip={tooltipContent}
                className={className}
                {...otherProps}
            />
        );
    }
}